import React from 'react';
import styled from 'styled-components';
import logoCarregando from './logo-tb-loading.svg';

// Carregamento das tabelas dos turnos (Programação Havan e Emissão de protocolo): logo TB animada, centralizada.
// O SVG anima sozinho (CSS interno) e respeita "reduzir movimento" do sistema.
const CarregandoTabela = ({ texto = 'Carregando…' }) => (
  <Area role="status" aria-live="polite">
    <Logo src={logoCarregando} alt="" aria-hidden="true" />
    <Texto>{texto}</Texto>
  </Area>
);

export default CarregandoTabela;

const Area = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 180px;
  padding: 24px 12px;
  border: 1px solid #d7e0ea;
  border-top: 0;
  background: #ffffff;
`;
const Logo = styled.img`width: 64px; height: auto;`;
const Texto = styled.span`color: #526275; font-size: 13px; font-weight: 600;`;
